import * as React from "react";
import "./style.css";
import BOTable, {
  BOHeader,
  BOColumns,
  BOColumn,
  BOBody,
  BORow,
  BOCell
} from "app/components/BOComponents/BOTable/BOTable";
import SmsProviderToggle from "./SmsProviderToggle";
import TestSmsProvider from "./TestSmsProvider";

type Props = {
  name: string;
  stats: {
    enabled: boolean;
    messages: {
      last_15: {
        success: number;
        fail: number;
      };
      last_60: {
        success: number;
        fail: number;
      };
    };
  };
};

export default class SmsProvider extends React.Component<Props, {}> {
  render() {
    const {
      name,
      stats: {
        enabled,
        messages: { last_15, last_60 }
      }
    } = this.props;

    return (
      <section className={`providerBlock ${name}`}>
        <div className="imageContainer" />

        <div>
          <BOTable
            name={`${name}_provider_status_table`}
            columns={
              <BOColumns>
                <BOColumn align="center">
                  <h3>Enabled</h3>
                </BOColumn>
                <BOColumn align="center">
                  <h3>Test</h3>
                </BOColumn>
              </BOColumns>
            }
            body={
              <BOBody>
                <BORow>
                  <BOCell>
                    <SmsProviderToggle isEnabled={enabled} provider={name} />
                  </BOCell>
                  <BOCell align="center">
                    <TestSmsProvider provider={name} />
                  </BOCell>
                </BORow>
              </BOBody>
            }
          />
        </div>

        <div style={{ marginTop: "10px" }}>
          <BOTable
            name={`${name}_provider_data_table`}
            header={<BOHeader title="LAST 15 MINUTES" />}
            columns={
              <BOColumns>
                <BOColumn align="center">
                  <h3>Delivered</h3>
                </BOColumn>
                <BOColumn align="center">
                  <h3>Failed</h3>
                </BOColumn>
              </BOColumns>
            }
            body={
              <BOBody>
                <BORow>
                  <BOCell align="center">{last_15.success}</BOCell>
                  <BOCell align="center">{last_15.fail}</BOCell>
                </BORow>
              </BOBody>
            }
          />
        </div>

        <div style={{ marginTop: "10px" }}>
          <BOTable
            name={`${name}_provider_data_table`}
            header={<BOHeader title="LAST 60 MINUTES" />}
            columns={
              <BOColumns>
                <BOColumn align="center">
                  <h3>Delivered</h3>
                </BOColumn>
                <BOColumn align="center">
                  <h3>Failed</h3>
                </BOColumn>
              </BOColumns>
            }
            body={
              <BOBody>
                <BORow>
                  <BOCell align="center">{last_60.success}</BOCell>
                  <BOCell align="center">{last_60.fail}</BOCell>
                </BORow>
              </BOBody>
            }
          />
        </div>
      </section>
    );
  }
}
